import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEthereum, faDocker } from '@fortawesome/free-brands-svg-icons';
import { faHouseFloodWater, faSatellite } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsBackend = [
    "Go",
    "Solidity",
    "Rust",
    "C++",
    "Linux",
    "Hardhat",
    "Remix",
    "Docker",
];

const labelsSEM = [
    "Copernicus EMS",
    "ICSMD",
    "GDACS",
    "GTS",
    "UNOSAT",
];

const labelsML = [
    "Sentinel-Hub",
    "PyTorch",
    "CUDA",
    "Scikit",
    "Scipy",
    "Hugging Face",
    "Matplotlib",
];

const labelsFrontend = [
    "Ethers.js",
    "Web3.js",
    "Metamask",

    "React",
    "NodeJS",
    "NPM",
    "Nginx",

    "APIs",
    "SQL Databases",
    
    // "FastAPI",
    // "Adminer",
    // "Grafana",
    // "MySQL",
    // "SQLite",
    // "PostgreSQL",
    // "MariaDB",
    // "MongoDB",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">

                <div className="skill">
                    <div className="skill-heading">
                        <h3>Distributed Ledger Technologies</h3>
                    </div>
                    <div className="top-row">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faEthereum} size="3x"/>
                        </div>
                        <div className="flex-chips">
                            {labelsBackend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill-text">
                        <p>Development of Distributed Ledger Technology (DLT) and other Web3 systems from the architecture itself to Smart Contracts executed upon blockchains.</p>
                    </div>
                    
                </div>

                <div className="skill">
                    <div className="skill-heading">
                        <h3>Satellite-based Emergency Mapping</h3>
                    </div>
                    <div className="top-row">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faHouseFloodWater} size="3x"/>
                        </div>
                        <div className="flex-chips">
                            {labelsSEM.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill-text">
                        <p>Researching and optimising the current Satellite-based Emergency Mapping protocols to provide Earth Observation information faster to those who need it. Looking at a range of natural disasters from Earthquakes and Tropical Cyclones to Flooding and Droughts in the Copernicus and ICSMD protocols.</p>
                    </div>
                    
                </div>

                <div className="skill">
                    <div className="skill-heading">
                        <h3>Earth Observation Machine Learning</h3>
                    </div>
                    <div className="top-row">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faSatellite} size="3x"/>
                        </div>
                        <div className="flex-chips">
                            {labelsML.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="skill-text">
                        <p>Automating Earth Observation analytics for Natural Disaster Response and Agricultural predictions. From classification and segmentation tasks to knowledge extrapolation using LLMs.</p>
                    </div>
                    
                </div>

                <div className="skill">
                    <div className="skill-heading">
                        <h3>Interfacing with Distributed Systems</h3>
                    </div>
                    <div className="top-row">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faDocker} size="3x"/>
                        </div>
                        <div className="flex-chips">
                            {labelsFrontend.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    
                    <div className="skill-text">
                        <p>Once the DLT architecture is built, I build bridges between Web2 and Web3 to help regular users connect to the next generation of the internet securely and safely.</p>
                    </div>
                    
                </div>

            </div>
        </div>
    </div>
    );
}

export default Expertise;